import { render, staticRenderFns } from "./rules-list-view.vue?vue&type=template&id=47333877&scoped=true"
import script from "./rules-list-view.vue?vue&type=script&lang=js"
export * from "./rules-list-view.vue?vue&type=script&lang=js"
import style0 from "./rules-list-view.vue?vue&type=style&index=0&id=47333877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47333877",
  null
  
)

export default component.exports